var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxWithArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.box-arrow-icon-st0{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00195 16H16.002V5H2.00195V16ZM7.55195 10V7H10.462V10H13.002L9.00195 14L5.00195 10H7.55195Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "box-arrow-icon-st0",
    d: "M13 10H10.45V7H7.55V10H5L9 14L13 10ZM17.54 2.23L16.15 0.55C15.88 0.21 15.47 0 15 0H3C2.53 0 2.12 0.21 1.84 0.55L0.46 2.23C0.17 2.57 0 3.02 0 3.5V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V3.5C18 3.02 17.83 2.57 17.54 2.23ZM3.24 2H14.76L15.57 2.97H2.44L3.24 2ZM16 16H2V5H16V16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxWithArrowIcon);
export default __webpack_public_path__ + "static/media/box_with_arrow-icon.d0ae78c1e53ac05cbf5545cf8e4dc056.svg";
export { ForwardRef as ReactComponent };